import get from 'lodash/get';

export default {
	siteSettings: (state) => state.siteSettings,
	miscSettings: (state) => state.miscSettings,
	defaultIntegrationId: (state) => state.siteSettings.defaultIntegration,
	hasGoogleAnalytics: (state) =>
		Boolean(state.siteSettings.globalAnalyticsID || state.siteSettings.globalAnalyticsProfile),
	hasDefaultIntegration: (state) => Boolean(state.siteSettings.defaultIntegration),
	defaultIntegrationProvider: (state, getters) => {
		const found = Object.keys(state.integrations).find((provider) => {
			return state.integrations[provider].find((integration) => {
				return getters.defaultIntegrationId === integration.id;
			});
		});
		return found || '';
	},
	providerIntegrations: (state) => (provider) => {
		return get(state, `integrations[${provider}]`, []);
	},
	accountProfiles: (state) => (accountId) => {
		return get(state, `analyticsProfiles[${accountId}]`, []);
	},
};
